export default __webpack_public_path__ + "static/media/step-bg2.bfd00c09.png";